import { render, staticRenderFns } from "./VolumeChartLegend.vue?vue&type=template&id=34441392"
import script from "./VolumeChartLegend.vue?vue&type=script&lang=js"
export * from "./VolumeChartLegend.vue?vue&type=script&lang=js"
import style0 from "./VolumeChartLegend.vue?vue&type=style&index=0&id=34441392&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports